var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Preview-not-available",
    transform: "translate(-0.000000, 0.393139)",
    style: {
      stroke: "var(--ion-color-primary-tint, #800A0A)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61541443,2.94769412 C21.038503,1.01123748 49.6466633,1.01663248 71.3450069,2.96286026       C70.1862751,14.404042 70.6547095,26.2886315 71.0963322,37.3636344 C71.3320638,43.2753078 71.5592899,48.9536157       71.5167541,54.2034907 C58.8002673,55.0110353 46.4334367,54.4251702 34.8625288,53.8798137 C22.7681702,53.3097861       11.5332203,52.7892262 1.65549103,53.8901858 C2.89232292,38.9091404 2.87914555,19.0618253 1.61541443,2.94769412 Z",
    id: "Rectangle",
    strokeWidth: 2,
    fillOpacity: 0.5,
    fill: "#FFFFFF",
    shapeRendering: "geometricPrecision"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9412718,21.5828909 C32.4059559,24.2452291 39.6859258,32.939362 44.3042409,35.5828909"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4764416,35.148148 C30.0613854,32.7279578 41.6745089,24.4130002 43.3278829,21.5828909"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPreview);
export default __webpack_public_path__ + "static/media/no-preview.5680a6e12a87da233f2fc5ceea42b10f.svg";
export { ForwardRef as ReactComponent };